<cpc-badge variant="important" class="special-offer" [nxPopoverTriggerFor]="popoverSpecialOffer"
  nxPopoverDirection="top" [closeOnClickOutside]="true" nxPopoverTrigger="click">
  <b translate>home.special-offer</b>
</cpc-badge>
<nx-popover #popoverSpecialOffer class="specialOfferPopup">
  <div translate style="width: 500px;">special-offer.popup</div>
</nx-popover>
<cpc-card-group variant="inactive">
  <cpc-card-header [title]="'active-insurance-group.travel-insurance' | translate"
    [badge]="'group-state.inactive' | translate" variant="inactive" icon="product-plane"></cpc-card-header>
  <cpc-card>
    <p style="text-align: center">
      <span translate>special-offer.message1</span><br /><strong translate [innerHTML]="'special-offer.message2' | translate "></strong>
    </p>
    <cpc-card-entry footer>
      <cpc-button size="small" title (click)="openLink(product.buyUrl, true)"><span
          translate>home.buy-today</span></cpc-button>
      <cpc-button size="small" mode="tertiary" (click)="openLink(product.learnMoreUrl)"><span
          translate>home.learn-more</span><cpc-icon icon="arrow-right"></cpc-icon></cpc-button>
    </cpc-card-entry>
  </cpc-card>
  <nx-icon name="product-present" class="present-icon"></nx-icon>
</cpc-card-group>
